/**
 * Klondike house rules.
 *
 * Solitaire has far fewer contested rules than Switch — the variation that
 * matters is almost entirely about how punishing the stock is. Turning one card
 * with unlimited redeals is close to always winnable; turning three with a
 * single pass is the version that ships in a physical box.
 */
export const TABLEAU_COLUMNS = 7;
/** Solitaire is played alone. Stated so the lobby has something to read. */
export const MIN_PLAYERS = 1;
export const MAX_PLAYERS = 1;
const BASE = {
    drawCount: 1,
    redeals: null,
    allowFoundationToTableau: true,
    anyCardFillsEmptyColumn: false,
};
export const RULE_PRESETS = [
    {
        id: 'relaxed',
        name: 'Turn One',
        description: 'One card at a time and as many passes through the stock as you like. Most deals come out.',
        rules: { ...BASE },
    },
    {
        id: 'standard',
        name: 'Turn Three',
        description: 'Three cards at a time, unlimited passes. The usual desktop-solitaire setting.',
        rules: { ...BASE, drawCount: 3 },
    },
    {
        id: 'vegas',
        name: 'Vegas',
        description: 'Three at a time and one pass through the stock only. Roughly one deal in six is winnable.',
        rules: { ...BASE, drawCount: 3, redeals: 0, allowFoundationToTableau: false },
    },
];
/** The set a fresh game starts with. */
export const DEFAULT_RULES = RULE_PRESETS[0].rules;
const BOOLEAN_KEYS = [
    'allowFoundationToTableau',
    'anyCardFillsEmptyColumn',
];
/**
 * Coerces untrusted input into a valid ruleset. Mirrors `sanitiseRules` on the
 * Switch side: anything unrecognised falls back to the default rather than
 * throwing, so a stale client can never wedge a game.
 */
export function sanitiseRules(input) {
    const raw = (input ?? {});
    const rules = { ...DEFAULT_RULES };
    for (const key of BOOLEAN_KEYS) {
        if (typeof raw[key] === 'boolean')
            rules[key] = raw[key];
    }
    if (raw.drawCount === 1 || raw.drawCount === 3)
        rules.drawCount = raw.drawCount;
    if (raw.redeals === null) {
        rules.redeals = null;
    }
    else if (typeof raw.redeals === 'number' && Number.isFinite(raw.redeals)) {
        rules.redeals = Math.min(16, Math.max(0, Math.round(raw.redeals)));
    }
    return rules;
}
//# sourceMappingURL=rules.js.map